module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n    Quick Links:\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('router-link', {
    staticClass: "link ic-style-guidelines",
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    }
  }, [_vm._v("Style Guidelines"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link ic-submit",
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    }
  }, [_vm._v("Submit a Paper"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link ic-peer-review",
    attrs: {
      "to": {
        name: 'forAuthorsPolicies',
        hash: '#peer-review'
      }
    }
  }, [_vm._v("Peer Review"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link ic-plagerism",
    attrs: {
      "to": {
        name: 'forAuthorsPolicies',
        hash: '#plagerism'
      }
    }
  }, [_vm._v("Plagerism"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-290ce35a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/sidebar/SidebarQuickLinksComponent.vue
// module id = 1409
// module chunks = 1